import React, { useContext, useEffect } from 'react'
import { ConfigurationContext } from '../../../context api/Configuration/ConfigurationContext'
import { useLeadType } from '../../../hooks/CompanyConfiguration/useLeadType'
import { sortByName } from '../../../shared/constants'
import CustomAddForm from '../../version-4/MasterForms/CustomAddForm'

export default function TaxForm({ form, setForm }) {
  const { convertFrom, convertTo, conversionDuration } = form
  //console.log('FORM : ', form)
  const { getAllLeadType } = useLeadType()
  const { leadType } = useContext(ConfigurationContext)

  useEffect(() => {
    getAllLeadType()
  }, [])

  let tempLeadType = convertFrom ? leadType && leadType.filter((item) => item._id !== convertFrom) : []
  //console.log('TEMP LEAD TYPE : ', tempLeadType)
  const inputField = [
    { label: 'From', value: convertFrom, name: 'convertFrom', options: sortByName(leadType), fieldName: 'name', fieldValue: '_id' },
    {
      label: 'To',
      value: convertTo,
      name: 'convertTo',
      options: sortByName(tempLeadType),
      disabled: convertFrom ? false : true,
      fieldName: 'name',
      fieldValue: '_id',
    },
    { label: 'Duration', value: conversionDuration, name: 'conversionDuration', type: 'NUMBER' },
  ]

  return <CustomAddForm state={form} setState={setForm} data={inputField} />
}
